import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiGetWhatsappNotifications, apiSetWhatsappNotifications } from 'services/TargetService';

export const fetchSwitcherState = createAsyncThunk(
  'settingWhatsapp/fetchState',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiGetWhatsappNotifications();
      // Convert is_enabled from "0"/"1" to boolean
      return response.data?.data?.map(item => ({
        ...item,
        is_enabled: item.is_enabled === '1'
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateSwitcherState = createAsyncThunk(
  'settingWhatsapp/updateState',
  async (preferences, { rejectWithValue }) => {
    try {
      const apiData = preferences.map(item => ({
        id: item.id,
        is_enabled: item.is_enabled ? '1' : '0',
      }));
      await apiSetWhatsappNotifications(apiData);
      return preferences;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const dataSlice = createSlice({
  name: 'settingWhatsapp',
  initialState: {
    notificationPreferences: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSwitcherState.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSwitcherState.fulfilled, (state, action) => {
        state.notificationPreferences = action.payload;
        state.loading = false;
      })
      .addCase(fetchSwitcherState.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateSwitcherState.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSwitcherState.fulfilled, (state, action) => {
        state.notificationPreferences = action.payload;
        state.loading = false;
      })
      .addCase(updateSwitcherState.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default dataSlice.reducer;
